<div class="container-fluid">
    <div class="row m-0 p-1 w-100">
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow">
                <form [formGroup]="filterform">
                    <div class="row m-0 header-filter">

                        <div class="col-md-2 d-flex my-auto">
                            <div class="my-auto ml-1 mr-2" *ngIf="nSubModule==2 || nSubModule==3 || nSubModule==4">
                                <div class="back pointer">
                                    <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                                </div>
                            </div>
                            <div class="custom-search form-group my-auto">
                                <input type="filter" formControlName="search" (keyup)="doSearch(term)" class="custom-search-input" placeholder="Search for" autocomplete="off" tabindex="1" [(ngModel)]="term">
                            </div>
                        </div>
                        <div class="col-md-9 row my-auto">
                            <ng-multiselect-dropdown class="col-md" [placeholder]="'All Assets'" [settings]="dropdownSettings" formControlName="asset_type_id" [data]="AssetsDataLists" (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)" (onSelectAll)="onSelectAll()"
                                (onDeSelectAll)="onDeSelectAll()">
                            </ng-multiselect-dropdown>

                            <ng-multiselect-dropdown class="col-md" [placeholder]="'All Creatives'" [settings]="dropdownSettings" [data]="CreativeDataLists" formControlName="creative_id" (onSelect)="onCreativeItemSelect($event)" (onDeSelect)="onCreativeItemDeSelect($event)" (onSelectAll)="onCreativeSelectAll()"
                                (onDeSelectAll)="onCreativeDeSelectAll()">
                            </ng-multiselect-dropdown>

                            <ng-multiselect-dropdown class="col-md" [placeholder]="'All Vendors'" [settings]="dropdownSettings" [data]="VendorDataLists" formControlName="vendor_id" (onSelect)="onVendorItemSelect($event)" (onDeSelect)="onVendorItemDeSelect($event)" (onSelectAll)="onVendorSelectAll()"
                                (onDeSelectAll)="onVendorDeSelectAll()">
                            </ng-multiselect-dropdown>

                            <ng-multiselect-dropdown class="col-md" *ngIf="nSubModule==2 || nSubModule==3" [placeholder]="'All Floors'" [settings]="dropdownSettings" [data]="f_FloorLists" formControlName="floor_id" (onSelect)="onFloorItemSelect($event)" (onDeSelect)="onFloorItemDeSelect($event)"
                                (onSelectAll)="onFloorSelectAll()" (onDeSelectAll)="onFloorDeSelectAll()">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="col-md-1 d-flex my-auto justify-content-end">
                            <div class="">
                                <button class="btn btn-reset align-items-center reset-align" (click)="clearFilters()"><u>Reset filter</u></button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="row m-0 p-1 w-100" *ngIf="nSubModule==1">
        <div class="col-lg-4 col-md-6 m-0 p-1" *ngIf="is_Admin_User">
            <div class="bg-white rounded shadow pb-3">
                <div class="col-12 p-4" *ngIf="isShowTab">
                    <ul id="myTab" role="tablist" class="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
                        <li class="nav-item flex-sm-fill">
                            <a id="state-tab" data-toggle="tab" href="#state" role="tab" aria-controls="state" aria-selected="true" class="nav-link border-0 text-uppercase font-weight-bold active">Region</a>
                        </li>
                        <li class="nav-item flex-sm-fill">
                            <a id="showroom-tab" data-toggle="tab" href="#showroom" role="tab" aria-controls="showroom" aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">Showroom</a>
                        </li>
                    </ul>
                </div>
                <div id="myTabContent" class="tab-content regionShowroomLists" *ngIf="isShowTab">
                    <div id="state" role="tabpanel" aria-labelledby="state-tab" class="tab-pane fade px-1 show active">
                        <div class="row justify-content-center mp-0">
                            <div class="col-md-6 col-sm-12 my-1 mx-auto" *ngFor="let data of RegionDataLists;let i=index">
                                <div class="box p-1 pointer text-center" (click)="onRegionClick(data.id,data.name)">
                                    <img class="img-fluid w-100 z-depth-1" onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" alt="">
                                    <p class="text-center text-black text-break text-uppercase m-0 p-2 font-weight-bold">{{data.name}}</p>
                                </div>
                            </div>
                            <div class="text-center p-3" *ngIf="RegionDataLists && RegionDataLists.length === 0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                </svg>
                                <p class="m-0 p-4 no-record"> No Record Found </p>
                            </div>
                        </div>
                    </div>
                    <div id="showroom" role="tabpanel" aria-labelledby="showroom-tab" class="tab-pane fade px-1">
                        <div class="row justify-content-center mp-0">
                            <div class="col-6 my-1 mx-auto" *ngFor="let data of ShowroomDataLists;let i=index">
                                <div class="box p-1 pointer text-center" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                                    <img class="img-fluid w-100 z-depth-1" onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" alt="">
                                    <p class="text-center text-black text-break text-uppercase m-0 p-2 font-weight-bold">{{data.name}}</p>
                                </div>
                            </div>
                            <div class="text-center p-3" *ngIf="ShowroomDataLists && ShowroomDataLists.length === 0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                </svg>
                                <p class="m-0 p-4 no-record"> No Record Found </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="" *ngIf="!isShowTab">
                    <div class="title-header d-flex">
                        <div class="col-3 my-auto">
                            <div class="back pointer">
                                <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                            </div>
                        </div>
                        <div class="text-left col-9 my-auto">
                            <span class="text-muted">Region : </span>
                            <h5 class="m-0 p-0">{{selected_region_name}}</h5>
                        </div>


                    </div>
                    <div class="regionShowroomLists row mp-0 justify-content-center">
                        <div class="col-6 my-1 mx-auto" *ngFor="let data of f_Region_Showroom_list;let i=index">
                            <div class="box p-1 pointer text-center" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                                <img class="img-fluid w-100 z-depth-1" onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" alt="">
                                <p class="text-center text-black text-break text-uppercase m-0 p-2 font-weight-bold">{{data.name}}</p>
                            </div>
                        </div>
                        <div class="text-center p-3" *ngIf="f_Region_Showroom_list && f_Region_Showroom_list.length === 0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                            </svg>
                            <p class="m-0 p-4 no-record"> No Record Found </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="is_Admin_User ? 'col-lg-8 col-md-6' : 'col-lg-12'" class="m-0 p-1">
            <div class="bg-white rounded shadow">
                <div class="title-header">
                    <h5 class="mp-0">INSTORE</h5>
                </div>
                <div class="p-2">
                    <div class="box-table expiry-table table-responsive  p-2">
                        <table class="table instore box-table table-borderless  m-0 p-0" matSort (matSortChange)="sortData($event)" matSortActive="" matSortDirection="asc" matSortDisableClear>
                            <thead class="">
                                <tr class="justify-content-center ">
                                    <!-- <th  mat-sort-header = "expiryDays" class="text-center" ><p class="m-0">Expiry Days</p></th> -->
                                    <th class="text-center">
                                        <p class="m-0">Expiry Days</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Region</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Showroom</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Floor</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Location</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Type</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Creative</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Vendor</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Name</p>
                                    </th>
                                    <th class="text-center">
                                        <p class="m-0">Size</p>
                                    </th>
                                </tr>

                            </thead>

                            <tbody class="">

                                <tr class="pointer" *ngFor="let data of FilteredInstoreExpiredLists| filter:term | slice: (page-1) * pageSize : page * pageSize;let i=index" (click)="showInstoreDetails(data)">
                                    <td class="text-center">
                                        <p class="m-0 font-weight-bold" [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.regionName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.showroomName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0 p-0">{{data.floorName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.locationName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.assetTypeName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.creativeName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.vendorName}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">{{data.name}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p class="m-0">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                                </tr>

                            </tbody>

                        </table>
                        <div class="text-center p-5" *ngIf="FilteredInstoreExpiredLists && FilteredInstoreExpiredLists.length === 0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                            </svg>
                            <p class="m-0 no-record"> No Record Found </p>
                        </div>

                    </div>
                </div>
                <div class="mt-3 sl-pagination text-center justify-content-center d-flex" *ngIf="FilteredInstoreExpiredLists && FilteredInstoreExpiredLists.length > 10">
                    <ngb-pagination [(page)]="page" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" [maxSize]="5" [collectionSize]="FilteredInstoreExpiredLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                </div>
            </div>

            <div class="col-lg-12 d-flex p-0">
                <div class="col-md-5 p-2 ">
                    <div class="d-flex  parent-box mt-2">
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(1)">
                            <div class="top-solid solid-green d-flex justify-content-center align-items-center" *ngIf="nExpiredAll">
                                {{nExpiredAll.length}}
                            </div>
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>All</p>
                            </div>
                        </div>
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(0)">
                            <div class="top-solid solid-red d-flex justify-content-center align-items-center" *ngIf="nExpired0">
                                {{nExpired0.length}}
                            </div>
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>Expired</p>
                            </div>
                        </div>
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(10)">
                            <div class="top-solid solid-orange d-flex justify-content-center align-items-center" *ngIf="nExpiredNot">
                                {{nExpiredNot.length}}
                            </div>
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>Not Expired</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7 p-2 ">
                    <div class="bg-white rounded shadow">
                        <div class="title-header">
                            <h5 class="mp-0">UNCHANGED ADS</h5>
                        </div>
                        <div class="table-responsive p-2">
                            <table class="table table-borderless m-0 p-0">
                                <thead class="">
                                    <tr class="justify-content-center ">
                                        <th class="text-center">
                                            <p class="m-0">10 Days</p>
                                        </th>
                                        <th class="text-center">
                                            <p class="m-0">30 Days</p>
                                        </th>
                                        <th class="text-center">
                                            <p class="m-0">6 Months</p>
                                        </th>
                                        <th class="text-center">
                                            <p class="m-0">2 Years</p>
                                        </th>
                                        <th class="text-center">
                                            <p class="m-0">5 Years</p>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody class="">
                                    <tr class="">
                                        <td class="text-center">
                                            <p class="m-0">{{nUnchange10}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="m-0">{{nUnchange30}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="m-0">{{nUnchange180}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="m-0">{{nUnchange720}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="m-0">{{nUnchange1825}}</p>
                                        </td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0 p-1 w-100" *ngIf="nSubModule==2">
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow pb-3 gallery-image">
                <div class="row m-0 p-2  d-flex">
                    <p class="m-0 p-0 breadcrumb">{{selected_region_name}}&nbsp;&nbsp;&#187;&nbsp;&nbsp;</p>
                    <p class="m-0 p-0 breadcrumb">{{selected_showroom_name}}</p>
                </div>
                <div class="p-1" *ngFor="let item of grouped_instoreLists">
                    <div class="title-header d-flex">
                        <h5 class="floor_name m-0">{{getFloorName(item.id)}}</h5>
                    </div>
                    <div class="img-grid mb-4 pointer p-1">
                        <div class="img-box p-1" *ngFor="let data of item.instoreData| filter:term;let i=index" (click)="showDetailedView(data.id,data.name)">
                            <div class="text-center">
                                <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" onerror="this.src='/assets/grt.svg'" alt="" />
                            </div>
                            <div class="p-2">
                                <div class="d-flex">
                                    <p class="img-grid-title">Type&nbsp;:&nbsp;</p>
                                    <p class="img-grid-content">{{data.assetTypeName}}</p>
                                </div>
                                <div class="d-flex">
                                    <p class="img-grid-title">Creative&nbsp;:&nbsp;</p>
                                    <p class="img-grid-content">{{data.creativeName}}</p>
                                </div>
                                <div class="d-flex">
                                    <p class="img-grid-title">Size&nbsp;:&nbsp;</p>
                                    <p class="img-grid-content">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                                </div>
                                <p class="img-grid-title">Particulars&nbsp;:&nbsp;</p>
                                <p class="img-grid-content">{{data.particulars}}</p>

                            </div>
                            <div class="row m-0" *ngIf="data.expiryDays <0 ">
                                <div class="ribbon">Expired ({{data?.expiryDays}} Days)</div>
                            </div>
                            <div class="row m-0" *ngIf="data.expiryDays >=0 && data.expiryDays <=30">
                                <div class="ribbon-e">Expiring in ({{data?.expiryDays}} Days)</div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center p-3" *ngIf="item.instoreData && item.instoreData.length === 0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                            <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                        </svg>
                        <p class="m-0 no-record"> No Record Found </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row m-0 p-1 w-100" *ngIf="nSubModule==3">
        <div class="m-0 p-1" [ngClass]="{'col-lg-5':isLog, 'col-lg-8':!isLog}">
            <div class="bg-white rounded shadow pb-3 floor-image">
                <div class="col-lg-12 row mp-0 w-100">
                    <div class="col-6 m-0 p-0">
                        <div class="d-flex m-0 p-2 pointer" *ngIf="is_Admin_can_Edit">
                            <input type="checkbox" id="checkAll" name="checkAll" [checked]="isAllInstoreChecked" class="m-1" (click)="checkAll()">
                            <label class="m-0 p-0 my-auto" for="checkAll" data-content=""> 
                                <p class="m-0 p-0 select-title">Select / Unselect all<span class="img-grid-title"> ( {{isAllInstoreChecked === true ? 'All Selected' : instoreCheckedLists.length+' Selected'}} )</span></p></label>
                        </div>
                    </div>
                    <div class="col-6 m-0 p-0">
                        <div class="d-flex justify-content-end detail-buttons p-1" *ngIf="instoreCheckedLists?.length > 1">
                            <button type="button" class="btn btn-success mr-2" (click)="bulkUpdateModify(true)">Save Changes</button>
                            <!-- <button type="button" class="btn btn-dark" (click)="bulkUpdateModify(false)">Modify</button> -->
                        </div>
                    </div>
                </div>
                <div class="regionShowroomLists m-0 p-0">
                    <div *ngFor="let item of grouped_instoreLists">
                        <div class="title-header d-flex">
                            <h5 class="floor_name m-0">{{getFloorName(item.id)}}</h5>
                        </div>
                        <div class="img-grid-container p-1 mb-4 pointer">
                            <div class="img-box" *ngFor="let data of item.instoreData| filter:term;let i=index" [ngStyle]="{'background-color': selectedInstore_ID === data.id ? '#fcb626' : '#FEF8EB' }">
                                <div class="gallery_images" (click)="clickInstore(data.id,data.name)">
                                    <div class="text-center">
                                        <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" onerror="this.src='/assets/grt.svg'" alt="" class="p-0" />
                                    </div>
                                    <div class="p-2">
                                        <div class="d-flex">
                                            <p class="img-grid-title">Type&nbsp;:&nbsp;</p>
                                            <p class="img-grid-content">{{data.assetTypeName}}</p>
                                        </div>
                                        <div class="d-flex">
                                            <p class="img-grid-title">Creative&nbsp;:&nbsp;</p>
                                            <p class="img-grid-content">{{data.creativeName}}</p>
                                        </div>
                                        <div class="d-flex">
                                            <p class="img-grid-title">Size&nbsp;:&nbsp;</p>
                                            <p class="img-grid-content">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                                        </div>
                                        <!-- <div class="d-flex"><p class="img-grid-title">Sqft&nbsp;:&nbsp;</p><p class="img-grid-content">{{splitNumber(data.size_w * data.size_h)}}</p></div> -->
                                        <div class="d-flex">
                                            <p class="img-grid-title">Vendor&nbsp;:&nbsp;</p>
                                            <p class="img-grid-content">{{data.vendorName}}</p>
                                        </div>
                                    </div>
                                    <div class="row m-0" *ngIf="data.expiryDays <=0 ">
                                        <div class="ribbon">Expired ({{data?.expiryDays}} Days)</div>
                                    </div>
                                    <div class="row m-0" *ngIf="data.expiryDays >=0 && data.expiryDays <=30">
                                        <div class="ribbon-e">Expiring in ({{data?.expiryDays}} Days)</div>
                                    </div>
                                </div>
                                <div class="text-right" *ngIf="is_Admin_User">
                                    <input class="checkbox" id="checkFollower" type="checkbox" [checked]="data.isChecked" (change)="setChecked(data.id)">
                                </div>
                            </div>
                        </div>
                        <div class="text-center p-3" *ngIf="item.instoreData && item.instoreData.length === 0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                            </svg>
                            <p class="m-0 no-record"> No Record Found </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-0 p-1" [ngClass]="{'col-lg-7':isLog, 'col-lg-4':!isLog}">
            <div class="bg-white rounded shadow">
                <div class="row m-0 p-2 d-flex">
                    <p class="m-0 p-0 img-grid-title">{{selected_region_name}}&nbsp;&nbsp;&#187;&nbsp;&nbsp;</p>
                    <p class="m-0 p-0 img-grid-title">{{selected_showroom_name}}</p>
                    <!-- <div *ngIf="!selAssetTypeValue.isNaN"><p class="m-0 p-0 img-grid-title">&nbsp;&nbsp;&#187;&nbsp;&nbsp;{{selectedAssetTypeName}}</p></div>
                    <div *ngIf="!selCreativeValue.isNaN"><p class="m-0 p-0 img-grid-title" >&nbsp;&nbsp;&#187;&nbsp;&nbsp;{{selectedCreativeName}}</p></div> -->
                </div>
                <div class="title-header">
                    <h5 class="mp-0">{{nameInstore}}</h5>
                </div>
                <div class="row mp-0 w-100">
                    <div class="col p-1 m-0" *ngIf="isLog">
                        <div class="box-table shadow">
                            <div class="card-title text-center p-1">Previous</div>
                            <div class="mx-auto text-center">
                                <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{instorePreviousData?.image}}" onerror="this.src='/assets/grt.svg'" class="detailed-img p-2">
                            </div>
                            <div class="details-info px-3">
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Installation Date</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.install_date}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Expiry Date</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.expiry_date}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Name</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.name}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Region</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.regionName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Showroom</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.showroomName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Floor</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.floorName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Location</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.locationName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Asset Type</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.assetTypeName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Creative</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.creativeName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Vendor</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.vendorName}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Size</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p class="mp-0">Width : {{splitNumber(instorePreviousData?.size_w)}}</p>
                                        <p class="mp-0">Height : {{splitNumber(instorePreviousData?.size_h)}}</p>
                                    </div>
                                </div>
                                <!-- <div class="form-group row">
                                    <div class="col-4 "><p>Square feet</p></div>
                                    <div class="col-8 ">
                                        <p class="mp-0">{{splitNumber(instorePreviousData?.size_w * instorePreviousData?.size_h)}}</p>
                                    </div>
                                </div> -->
                                <div class="form-group row">
                                    <div class="col-4 ">
                                        <p>Particulars</p>
                                    </div>
                                    <div class="col-8 ">
                                        <p>{{instorePreviousData?.particulars}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col p-1 m-0">
                        <div class="box-table shadow">
                            <div class="navbarheader m-0 p-0">
                                <div class="header-title card-title p-1">Current</div>
                                <div *ngIf="is_Admin_can_Edit">
                                    <div class='header-right icon social print mt-1 mr-2' *ngIf="!isEdit" ngbTooltip="Edit" (click)="editInstore()"><i class='fa fa-pencil'></i></div>
                                    <div class='header-right icon social print mt-1 mr-2' *ngIf="isEdit" ngbTooltip="Cancel" (click)="cancelEditInstore()"><i class='fa fa-ban'></i></div>
                                </div>
                            </div>
                            <div class="" *ngIf="!isEdit">
                                <div class="mx-auto text-center">
                                    <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{instoreCurrentData?.image}}" onerror="this.src='/assets/grt.svg'" class="detailed-img p-1">
                                </div>
                                <div class="details-info px-3">
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Installation Date</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.install_date| date: 'dd/MM/yyyy'}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Expiry Date</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.expiry_date| date: 'dd/MM/yyyy'}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Name</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.name}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Region</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.regionName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Showroom</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.showroomName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Floor</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.floorName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Location</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.locationName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Asset Type</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.assetTypeName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Creative</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.creativeName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Vendor</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p>{{instoreCurrentData?.vendorName}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Size</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p class="mp-0">Width : {{splitNumber(instoreCurrentData?.size_w)}}</p>
                                            <p class="mp-0">Height : {{splitNumber(instoreCurrentData?.size_h)}}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="form-group row">
                                        <div class="col-4 "><p>Square feet</p></div>
                                        <div class="col-8 ">
                                            <p class="mp-0">{{splitNumber(instoreCurrentData?.size_w * instoreCurrentData?.size_h)}}</p>
                                        </div>
                                    </div> -->
                                    <div class="form-group row">
                                        <div class="col-4 ">
                                            <p>Particulars</p>
                                        </div>
                                        <div class="col-8 ">
                                            <p> {{instoreCurrentData?.particulars}}</p>
                                        </div>
                                    </div>
                                    <!-- <div class="form-group row">
                                        <div class="col-4 "><p>Status</p></div>
                                        <div class="col-8 "><p>{{getExipreName(instoreCurrentData?.expiryDays)}}</p></div>
                                    </div> -->
                                    <div class="form-group row">
                                        <div class="col-4">
                                            <p>Expiry</p>
                                        </div>
                                        <div class="col-8">
                                            <p class="" [ngStyle]="{'color':getColor(instoreCurrentData?.expiryDays)}"><b>{{instoreCurrentData?.expiryDays}} Days</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- {{getExipreName(instoreCurrentData?.expiry_date)}} -->
                            <div *ngIf="isEdit">
                                <div [formGroup]="form" class="form-horizontal">
                                    <div class="row m-0 p-0 w-100">
                                        <div class="col-md-12 m-0 p-0">
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Instore Name</div>
                                                    </div>
                                                    <input type="text" class="form-control" formControlName="name" placeholder="" required>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Floor</div>
                                                    </div>
                                                    <select #floor_ class="custom-select-dialog round" formControlName="floor_id" (change)="onChangeFloor(floor_,true)" required>
                                                      <option value="">Select Floor</option>
                                                      <option *ngFor="let data of f_FloorLists" [ngValue]="data.id">{{data.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">

                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Location</div>
                                                    </div>
                                                    <select class="custom-select-dialog round" formControlName="location_id" required>
                                                <option value="">Select Location</option>
                                                <option *ngFor="let data of f_locationLists" [ngValue]="data.id">{{data.name}}</option>
                                                </select>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Asset Type</div>
                                                    </div>
                                                    <select class="custom-select-dialog round" formControlName="asset_type_id" required>
                                                    <option value="">Select Asset</option>
                                                    <option *ngFor="let data of AssetsDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                                </div>
                                            </div>

                                            <div class="row m-0 p-0">

                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Creative</div>
                                                    </div>
                                                    <select class="custom-select-dialog round" formControlName="creative_id" required>
                                                  <option value="">Select Creative</option>
                                                  <option *ngFor="let data of CreativeDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                </select>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Vendor</div>
                                                    </div>
                                                    <select class="custom-select-dialog round" formControlName="vendor_id" required>
                                                    <option value="">Select Vendor</option>
                                                    <option *ngFor="let data of VendorDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-6 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Width</div>
                                                    </div>
                                                    <input type="number" class="form-control" formControlName="size_w" placeholder="" (change)="onWidthChange()" required>
                                                </div>
                                                <div class="input-group col-md-6 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Height</div>
                                                    </div>
                                                    <input type="number" class="form-control" formControlName="size_h" placeholder="" (change)="onHeightChange()" required>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Sq. Feet</div>
                                                    </div>
                                                    <input type="number" class="form-control" formControlName="square_feet" placeholder="" required disabled>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Particulars</div>
                                                    </div>
                                                    <input type="text" class="form-control" formControlName="particulars" placeholder="" required>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Installation Date</div>
                                                    </div>
                                                    <!-- <input class="form-control" matInput [max]="form.controls['expiry_date'].value" formControlName="install_date" (dateChange)="startDateClicked($event)" 
                                                            [matDatepicker]="picker1" placeholder="Choose a date" >
                                                            <mat-datepicker-toggle matSuffix [for]="picker1" #startDateToggle></mat-datepicker-toggle>
                                                            <mat-datepicker #picker1></mat-datepicker> -->

                                                    <input class="form-control" matInput formControlName="install_date" (dateChange)="startDateClicked($event)" [matDatepicker]="picker1" placeholder="Choose a date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker1" #startDateToggle></mat-datepicker-toggle>
                                                    <mat-datepicker #picker1></mat-datepicker>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">Expiry Date</div>
                                                    </div>
                                                    <input class="form-control" matInput [min]="form.controls['install_date'].value" formControlName="expiry_date" (dateChange)="endDateClicked($event)" [matDatepicker]="picker2" placeholder="Choose a date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker2" #endDateToggle></mat-datepicker-toggle>
                                                    <mat-datepicker #picker2></mat-datepicker>
                                                </div>
                                            </div>
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                    <label class="label-header">Instore Image:</label>
                                                    <div class="uploader">

                                                        <input id="file-upload" type="file" name="fileUpload" accept="image/*" (change)="onFileChange($event)" />

                                                        <label for="file-upload" id="file-drag">
                                                      <img [src]="imageSrc" *ngIf="imageSrc" onerror="this.src='/assets/grt.svg'"  id="file-image">
                                                      <div id="start" *ngIf="!imageSrc">
                                                        <i class="fa fa-download" aria-hidden="true"></i>
                                                        <div class="label-header">Select a Picture</div>
                                                      </div>
                                                    </label>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="col-lg-12 d-flex justify-content-center detail-buttons p-1 mb-3" *ngIf="is_Admin_User">
                                                <button type="button" class="btn btn-danger mr-2" (click)="discontinue()">Discontinue</button>
                                                <button type="button" class="btn btn-success mr-2" (click)="onInstoreSingleUpdate()">Save Changes</button>
                                                <!-- <button type="button" class="btn btn-dark" (click)="onInstoreSingleModify()">Modify</button> -->
                                            </div>
                                            <div class="col-lg-12 d-flex justify-content-center detail-buttons p-1 mb-3" *ngIf="!is_Admin_User">
                                                <button type="button" class="btn btn-danger mr-2" (click)="instoreRequestEmail(0)">Damaged</button>
                                                <button type="button" class="btn btn-success mr-2" (click)="instoreRequestEmail(1)">Replacement</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="row m-0 p-1 w-100" *ngIf="nSubModule==4">
    <div class="col-lg-12 m-0 p-1">
        <app-modifyinstore [selectedInstore]="instoreCheckedLists"></app-modifyinstore>
    </div>
</div>